import L from 'leaflet';
import 'leaflet-measure';

/**
 * Adds the measure plugin to the leaflet map.
 *
 * @param {object} leafletMap - The leaflet map object.
 */
const addMeasurePlugin = leafletMap => {
  const measureControl = L.control.measure({
    position: 'topright',
    primaryLengthUnit: 'kilometers',
    secondaryLengthUnit: 'meters',
    primaryAreaUnit: 'hectares',
    localization: 'en',
    decPoint: ',',
    thousandsSep: ' '
  });
  measureControl.addTo(leafletMap);
};

export default addMeasurePlugin;
